import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "svg-icon svg-icon-4x" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        style: {"list-style":"none","float":"left","width":"160px"},
        class: "m-5"
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_inline_svg, {
            src: '/images/icons' + icon
          }, null, 8, ["src"]),
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(icon), 1)
        ])
      ]))
    }), 128))
  ]))
}